export enum SpinnerUiType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export type SpinnerProps = {
  uiType?: SpinnerUiType;
  noBackground?: boolean;
};
